import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, tokens } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [favIds, setFavIds] = useState(new Set());

  const loadFavs = useCallback(async () => {
    try { const { data } = await api.get("/favorites/ids"); setFavIds(new Set(data)); } catch { /* ignore */ }
  }, []);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      loadFavs();
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, [loadFavs]);

  useEffect(() => {
    if (tokens.access()) refreshUser();
    else setUser(false);
  }, [refreshUser]);

  const handleAuth = (data) => {
    tokens.set(data.access_token, data.refresh_token);
    setUser(data.user);
    loadFavs();
    return data.user;
  };

  const login = async (email, password) => handleAuth((await api.post("/auth/login", { email, password })).data);
  const register = async (name, email, password) => handleAuth((await api.post("/auth/register", { name, email, password })).data);
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    tokens.clear();
    setUser(false);
    setFavIds(new Set());
  };

  const toggleFav = async (id) => {
    const { data } = await api.post(`/favorites/${id}`);
    setFavIds((s) => { const n = new Set(s); data.is_favorite ? n.add(id) : n.delete(id); return n; });
    return data.is_favorite;
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, register, logout, refreshUser, favIds, toggleFav }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
